import React from 'react';
import { render } from 'react-dom';
import jwt from 'jsonwebtoken';
import axios from 'axios';
import CommonConstants from './utils/CommonConstants';

//Actions
import { setCurrentUser, } from './actions/Signin';
import { signedIn, } from './actions/Signin';
import { getParcel, } from './actions/ParcelAction';

//Utils
import setAuthorizationToken from './utils/setAuthorizationToken';

//Import Components
import App from './components/App';
import DashboardConnection from './components/DashboardFiles/DashboardConnection';
import Home from './components/Home';
import TestLogin from './components/TestLogin';
import SignInContainer from './components/SignInContainer';
import SignUpContainer from './components/SignUpContainer';
// import Promo from './components/Promo';
import SignupSuccess from './components/SignupSuccess';
import ShippingEstimate from './components/ShippingEstimate';
import Checkout from './components/Checkout';
import TrackPackage from './components/TrackPackage';
import AdyenPayment from './components/AdyenPayment';
import TrackDetail from './components/TrackDetail';
import Track from './components/Track';
import ChangePassword from './components/ChangePassword';
import ResetPassword from './components/ResetPassword';
import CheckOutSuccess from './components/CheckOutSuccess';
import Cms from './components/Cms';
import Dashboard from './components/Dashboard/Dashboard.js';
import Cart from './components/DashboardFiles/Cart';
import Parcel from './components/DashboardFiles/Parcel';
import Shipment from './components/DashboardFiles/Shipment';
import Account from './components/DashboardFiles/Account';
import ProhibitedItemsDashboard from './components/DashboardFiles/ProhibitedItems';
import Notification from './components/Notification';
import USShopping from './components/USShopping/USShopping';
import UKShopping from './components/UKShopping/UKShopping';
import OTP from './components/OneTimePassword';
import BuyForMe from './components/BuyForMe/index';

//import react router deps
import { Router, Route, IndexRoute, } from 'react-router';
import store, { history } from './store';
import { Provider } from 'react-redux';
import OffsizeItemsDashboard from './components/DashboardFiles/OffsizeItems';

const apiUrl = CommonConstants.Actions.api;

if (localStorage.jwtToken) {
  setAuthorizationToken(localStorage.jwtToken);
  store.dispatch(setCurrentUser(jwt.decode(localStorage.jwtToken)));
  store.dispatch(signedIn(localStorage.jwtToken));
  if (window.location.pathname !== '/otp-service'){
    store.dispatch(getParcel(localStorage.jwtToken));
  }
}

var authenticateCTR = true;
// If user is authenticated
var Authenticated = (nextState, replace, callback) => {

  axios.get(apiUrl + 'accounts').then((response) => {
    if (response.data.status === 200 && authenticateCTR) {
      replace('/cart')
      authenticateCTR = false;
    }
    callback()
  }).catch(() => {
    callback()
  })
}
// If user is not authenticated
var UnAuthenticated = (nextState, replace, callback) => {
  axios.get(apiUrl + 'accounts').then((response) => {
    if (response.data.status !== 200 && authenticateCTR) {
      replace('/signin')
      authenticateCTR = false;
    }
    callback()
  })
    .catch(() => {
      replace('/signin');
      callback()
    })
}
// scroll to hash
function hashLinkScroll() {
  const { hash } = window.location;
  if (hash !== '' && window.outerWidth < 420) {
    // Push onto callback queue so it runs after the DOM is updated,
    // this is required when navigating from a different page so that
    // the element is rendered on the page before trying to getElementById.
    setTimeout(() => {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView(true);
      } else {
        window.scrollTo(0, 0)
      }
    }, 0);
  } else {
    window.scrollTo(0, 0)
  }
}
const router = (

  <Provider store={store}>
    <Router history={history} onUpdate={hashLinkScroll}>
      <Route path="/"
        component={App}>
        <IndexRoute component={Home}></IndexRoute>
        <Route path="/home" component={Home}></Route>
        {/* <Route path="/promotions" component={Promo}></Route> */}
        <Route path="/shipping-estimate" component={ShippingEstimate}></Route>
        <Route path="/tracking/:id" component={TrackDetail} onEnter={UnAuthenticated}></Route>
        <Route path="/god-mode-login" component={TestLogin}></Route>
        <Route path="/notification" component={Notification}></Route>
        <Route path="/shop-in-us" component={USShopping}></Route>
        <Route path="/shop-in-uk" component={UKShopping}></Route>
        <Route path="/otp-service" component={OTP}></Route>
        <Route path="/buy-for-me" component={BuyForMe}></Route>
        <Route path="/track/:id" component={Track}></Route>
        <Route path="/track" component={Track}></Route>
      </Route>

      <Route path="/" component={DashboardConnection} >
        <IndexRoute component={Cart}></IndexRoute>
        <Route path="/dashboard" component={Dashboard} onEnter={UnAuthenticated}></Route>
        <Route path="/prohibited" component={ProhibitedItemsDashboard} onEnter={UnAuthenticated} ></Route>
        <Route path="/offsize" component={OffsizeItemsDashboard} onEnter={UnAuthenticated} ></Route>
        <Route path="/cart" component={Cart} > </Route>
        <Route path="/parcel/:id" component={Parcel} onEnter={UnAuthenticated}> </Route>
        <Route path="/account" component={Account} onEnter={UnAuthenticated}></Route>
        <Route path="/shipment" component={Shipment} onEnter={UnAuthenticated}></Route>
        <Route path="/signUp-success" component={SignupSuccess} onEnter={UnAuthenticated}></Route>
        <Route path="/checkout" component={Checkout}></Route>
        <Route path="/change-password" component={ChangePassword}></Route>
        <Route path="/reset-password" component={ResetPassword} onEnter={Authenticated}></Route>
        <Route path="/track-package" component={TrackPackage} onEnter={UnAuthenticated}></Route>
        <Route path="/adyen-payment" component={AdyenPayment}></Route>
        <Route path="/checkout-success" component={CheckOutSuccess}></Route>
      </Route>

      <Route path="/signin" component={SignInContainer} onEnter={Authenticated}></Route>
      <Route path="/signup" component={SignUpContainer} onEnter={Authenticated}></Route>

      <Route path="/" component={App} onUpdate={hashLinkScroll}>
        <IndexRoute component={Home}></IndexRoute>
        <Route path="/:cms" component={Cms}></Route>
      </Route>

    </Router>
  </Provider>
)

render(router, document.getElementById('root'));



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/